var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-th',{staticClass:"text-nowrap",attrs:{"aria-sort":_vm.ariaSort},on:{"click":_vm.columnHeaderClick}},[_vm._t("default"),_c('span',{staticClass:"sr-only"},[_vm._v(" (Click to sort "+_vm._s(_vm.clickDescriptionSort)+")")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }